import React from "react";
import Label from "./Label";
import TextInput from "./TextInput";

const InputGroup = ({
  onChange,
  value,
  id,
  name,
  label,
  disabled,
  readOnly,
  placeholder,
  onBlur,
  type,
  Icon,
  iconPosition = "left",
  addOn,
  numbersOnly,
  hasError = "",
}) => {
  return (
    <div className="w-full">
      {label && <Label>{label}</Label>}
      <div className="relative flex rounded-md shadow-sm">
        {Icon && (
          <div
            className={`pointer-events-none absolute inset-y-0 flex items-center ${
              iconPosition === "left" ? "left-0 pl-3" : "right-0 pr-3"
            } `}
          >
            <Icon />
          </div>
        )}
        {addOn && (
          <span className="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-50 px-3 text-gray-500 sm:text-sm">
            {addOn}
          </span>
        )}
        <TextInput
          id={id}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          readOnly={readOnly}
          placeholder={placeholder}
          iconPosition={iconPosition}
          hasIcon={Icon ? true : false}
          hasAddOn={addOn}
          numbersOnly={numbersOnly}
          hasError={hasError}
          isInputGroup={true}
        />
      </div>
      {hasError && (
        <span className="text-red-500 text-sm block mt-1">{hasError}</span>
      )}
    </div>
  );
};
export default InputGroup;
